(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-products"] && !Shopify.designMode) return;
  try {
    
  class hahahaHorizontalScroll {
    constructor(container) {
      this.section = container;
      this.scrollWrapper = container.querySelector('.hahaha-scroll-wrapper');
      this.track = container.querySelector('.hahaha-scroll-track');
      this.prevBtn = container.querySelector('.prev');
      this.nextBtn = container.querySelector('.next');
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.init();
    }

    init() {
      if (!this.scrollWrapper || !this.track || !this.prevBtn || !this.nextBtn) return;

      // Button-based scroll: each click moves 200px
      this.prevBtn.addEventListener('click', () => this.scrollFixed('left'));
      this.nextBtn.addEventListener('click', () => this.scrollFixed('right'));
      this.scrollWrapper.addEventListener('scroll', () => this.updateButtons());

      // Mouse drag to scroll (with passive:false to allow preventDefault)
      this.scrollWrapper.addEventListener('mousedown', (e) => this.onMouseDown(e), { passive: false });
      this.scrollWrapper.addEventListener('mouseleave', () => this.onMouseLeave());
      this.scrollWrapper.addEventListener('mouseup', () => this.onMouseUp());
      this.scrollWrapper.addEventListener('mousemove', (e) => this.onMouseMove(e), { passive: false });

      window.addEventListener('resize', () => this.updateButtons());
      this.updateButtons();
    }

    scrollFixed(direction) {
      const offset = direction === 'right' ? 500 : -500;
      this.scrollWrapper.scrollBy({ left: offset, behavior: 'smooth' });
    }

    updateButtons() {
      const sLeft = this.scrollWrapper.scrollLeft;
      const maxScroll = this.scrollWrapper.scrollWidth - this.scrollWrapper.clientWidth;
      if (this.prevBtn) {
        this.prevBtn.disabled = sLeft <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = sLeft >= maxScroll - 1;
      }
    }

    onMouseDown(e) {
      this.isDown = true;
      this.startX = e.pageX - this.scrollWrapper.offsetLeft;
      this.scrollLeft = this.scrollWrapper.scrollLeft;
      this.scrollWrapper.classList.add('active');
      if (e.cancelable) e.preventDefault();
    }

    onMouseLeave() {
      this.isDown = false;
      this.scrollWrapper.classList.remove('active');
    }

    onMouseUp() {
      this.isDown = false;
      this.scrollWrapper.classList.remove('active');
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      if (e.cancelable) e.preventDefault();
      const x = e.pageX - this.scrollWrapper.offsetLeft;
      const walk = x - this.startX;
      this.scrollWrapper.scrollLeft = this.scrollLeft - walk;
      this.updateButtons();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.hahaha-scroll-section.horizontal-scroll');
    sections.forEach((section) => new hahahaHorizontalScroll(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
class EditorialHero {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll(".img-slide");
    this.thumbs = section.querySelectorAll(".thumb");
    this.form = section.querySelector(".prod-form");
    this.descWrapper = section.querySelector(".prod-desc-wrapper");
    this.hoursEl = section.querySelector('[data-unit="hours"]');
    this.minutesEl = section.querySelector('[data-unit="minutes"]');
    this.secondsEl = section.querySelector('[data-unit="seconds"]');
    this.saleEndDate = section.dataset.saleEnd;
    this.storageKey = 'editorial_hero_timer_' + section.dataset.sectionId;
    
    this.init();
  }

  init() {
    this.thumbs.forEach(thumb => 
      thumb.addEventListener("click", () => this.switchImg(thumb))
    );
    
    if (this.form) {
      this.form.addEventListener("submit", e => this.handleAdd(e));
    }
    
    if (this.descWrapper) {
      this.descWrapper.addEventListener("click", () => this.expandDesc());
    }
    
    if (this.hoursEl) {
      this.startCountdown();
    }
  }

  switchImg(thumb) {
    const index = thumb.dataset.index;
    this.slides.forEach(slide => slide.classList.remove("active"));
    this.thumbs.forEach(t => t.classList.remove("active"));
    this.slides[index].classList.add("active");
    thumb.classList.add("active");
  }

  expandDesc() {
    if (this.descWrapper) {
      this.descWrapper.classList.add("expanded");
    }
  }

  startCountdown() {
    // Get or initialize timer end time from localStorage
    let endTime = localStorage.getItem(this.storageKey);
    
    if (!endTime) {
      // Generate random time between 5-9 hours
      const minHours = 5;
      const maxHours = 9;
      const randomHours = Math.random() * (maxHours - minHours) + minHours;
      const randomMinutes = Math.random() * 60;
      const randomSeconds = Math.random() * 60;
      
      const totalMilliseconds = 
        (randomHours * 60 * 60 * 1000) + 
        (randomMinutes * 60 * 1000) + 
        (randomSeconds * 1000);
      
      endTime = Date.now() + totalMilliseconds;
      localStorage.setItem(this.storageKey, endTime);
    } else {
      endTime = parseInt(endTime);
    }

    const updateTimer = () => {
      const now = Date.now();
      let remaining = endTime - now;

      if (remaining <= 0) {
        // Timer expired - reset with new random time
        const minHours = 5;
        const maxHours = 9;
        const randomHours = Math.random() * (maxHours - minHours) + minHours;
        const randomMinutes = Math.random() * 60;
        const randomSeconds = Math.random() * 60;
        
        const totalMilliseconds = 
          (randomHours * 60 * 60 * 1000) + 
          (randomMinutes * 60 * 1000) + 
          (randomSeconds * 1000);
        
        endTime = Date.now() + totalMilliseconds;
        localStorage.setItem(this.storageKey, endTime);
        remaining = totalMilliseconds;
      }

      const h = Math.floor(remaining / (1000 * 60 * 60));
      const m = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((remaining % (1000 * 60)) / 1000);

      this.hoursEl.textContent = String(h).padStart(2, "0");
      this.minutesEl.textContent = String(m).padStart(2, "0");
      this.secondsEl.textContent = String(s).padStart(2, "0");
    };

    updateTimer();
    this.countdownInterval = setInterval(updateTimer, 1000);
  }

  handleAdd(e) {
    e.preventDefault();
    const formData = new FormData(this.form);
    
    fetch("/cart/add.js", {
      method: "POST",
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      window.location.href = "/cart";
    })
    .catch(err => {
      console.error("Error:", err);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".editorial-hero").forEach(section => {
    new EditorialHero(section);
  });
});

  } catch(e) { console.error(e); }
})();
})();
